import { create } from "zustand"
import { persist } from "zustand/middleware"

export type Locale = "es" | "ca" | "en"

interface LocaleStore {
	locale: Locale
	setLocale: (locale: Locale) => void
}

export const useLocaleStore = create<LocaleStore>()(
	persist(
		(set) => ({
			locale: "ca",
			setLocale: (locale) => set({ locale }),
		}),
		{
			name: "locale-store-licitacions",
			partialize: (state) => ({ locale: state.locale }),
		}
	)
)
